import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='OneShop Team' dateTime='2022-01-22' tag='Poshmark' title='Poshmark Wholesale: Is It Worth It?'>
        <p>
          Poshmark is a popular social media app for buying and selling clothes. Many people are interested in becoming
          Poshmark wholesalers but don't know how to do it or if it's worth their time. This blog will cover everything
          you need to know about being a Poshmark wholesale vendor, what Poshmark wholesale means, and why you should
          want to be one. This blog will also cover what is required of someone who wants to become a Poshmark wholesale
          vendor and tips on how to get started with the Poshmark wholesale market.{' '}
        </p>

        <h3>What is Poshmark Wholesale</h3>
        <p>
          Poshmark is a retail app that allows you to buy and sell secondhand clothing and accessories. There are two
          ways to use Poshmark: selling items you no longer want or purchasing items at discounted prices. One of the
          most popular things people do on Poshmark is buy in bulk, then resell the clothes for profit on their own
          profiles.{' '}
        </p>
        <p>
          Poshmark wholesale is a way for you to buy in bulk and sell on the app. Buying in bulk or "wholesaling" can be
          profitable if you know what you're doing. But not all wholesalers are successful, so it's essential to
          understand how to do this correctly. Let’s break down how the Poshmark wholesale works and what requirements
          are needed to become a wholesale vendor.{' '}
        </p>

        <h3>How Poshmark Wholesale Works</h3>
        <p>
          The Poshmark wholesale market is a portal where you can buy items to sell in your Poshmark shop. Poshmark
          caters to over 200 emerging and known brands with a wide selection of categories you can choose from. If you
          want to extend your shop to more markets, including women, men, kids, and even luxury goods, Poshmark
          wholesale is your go-to source for expanding your inventory.
        </p>
        <p>
          Poshmark wholesale simply works like this, Posh sellers will shop from a wide range of wholesale retailers
          such as April Spirit, Fringe & the likes. After purchasing and availing of the MOQ (Minimum Order Quantities)
          you can now add it to your closet. Unfortunately, Poshmark wholesale is not available for everyone. You must
          meet specific criteria and requirements before you can unlock access to the wholesale market.{' '}
        </p>

        <h3>How to Become a Wholesale Vendor</h3>
        <p>
          In order to become a Poshmark wholesale vendor, you must obtain wholesale certification first before you can
          purchase wholesale directly on Poshmark.{' '}
        </p>
        <p>Wholesale certification qualifications: </p>
        <ul>
          <li>You must have ten successful transactions on your account</li>
          <li>You must have an average rating of 4.5+ </li>
        </ul>
        <p>
          Remember that in order to buy wholesale items on Poshmark, you must also meet the required MOQ or Minimum
          Order Quantities of the brand you want to stock up on your inventory. In order to get a low price, you must
          comply with the MOQ of the brand.{' '}
        </p>
        <p>
          Once you meet these criteria, you can now apply for wholesale certification. In most cases, the app will
          notify you after meeting these criteria that you can now purchase wholesale directly on the Poshmark app.{' '}
        </p>

        <h3>How to Buy in Wholesale Market </h3>
        <p>
          Buying wholesale directly on the Poshmark platform is simple and straightforward. Simply follow these steps to
          access the wholesale market.
        </p>
        <p>In the Mobile App </p>
        <ol>
          <li>Click “Menu” on the top left of your app</li>
          <li>Select “Wholesale.”</li>
          <li>Start stocking up your inventory </li>
        </ol>
        <p>On the Web </p>
        <ol>
          <li>Click “Posh Markets” </li>
          <li>Scroll down, and you will find a page listed for wholesale </li>
          <li>Shop and stock up your inventory </li>
        </ol>
        <p>
          Remember that you must meet the criteria to become a wholesale vendor before accessing the wholesale market on
          your app. After you make your first wholesale purchase, the brand will ship your items within 3-7 days after
          purchase. Once the items have been delivered to your doorstep, the next step is to style, photograph, and list
          them in your closet by tagging them as Boutique in the listing details.
        </p>

        <h3>Listing a Boutique Items </h3>
        <p>
          Posh sellers must complete boutique certification in order to mark their listings under Boutique Status.
          Listing a boutique item is the same as listing non-boutique items. Getting your boutique certification is
          simple. You can do it on your mobile app or on a computer. All you need to do is go to your account tab, then
          click "My Sellers Tools", then click "Boutique Certification to complete the initial steps.
        </p>
        <p>
          After completing the certification, you must meet the following criteria to unlock the Poshmark Wholesale
          Market.{' '}
        </p>
        <ul>
          <li>Items purchased wholesale or directly from a distributor</li>
          <li>Item must be new and being sold to the public for the first time</li>
          <li>Items purchased from a retail store for resale cannot be tagged as boutique </li>
          <li>You must include its original photography</li>
        </ul>
        <p>
          Listing and tagging your item as "Boutique" helps buyers differentiate your items from other similar items on
          the platform. Plus, Poshmark has Posh Market exclusive to Boutiques. Having an item listed under this status
          highlights your closets.
        </p>
        <p>
          Other benefits of having a boutique in your closet also give you advantages in joining posh parties exclusive
          for Boutiques, and that you have lesser competitors on the platform. Most Poshmark sellers focus on selling
          gently-used items, which gives you advantages to sell on more buyers actively looking for new or unworn items.
        </p>

        <h3>How to List Poshmark Boutique Items </h3>
        <p>To mark items as a Poshmark boutique, simply follow these step by step guides: </p>
        <p>In the Poshmark App: </p>
        <ol>
          <li>Go to your account and click “Sell.” </li>
          <li>Find and Click “New With Tags”</li>
          <li>Tap “Yes” to view Boutique options</li>
          <li>Toggle the “ON” button beside the boutique </li>
          <li>Click “Done.”</li>
        </ol>
        <p>On the Website </p>
        <ol>
          <li>Go to your account and select “Sell on Poshmark.” </li>
          <li>Click “New With Tags” </li>
          <li>Tap “Yes” to view Boutique options</li>
          <li>Select “Yes” under “Add this item to your boutique?” </li>
        </ol>
        <p>
          You don’t need a wholesale license to list boutique items on Poshmark. However, if you plan to purchase from
          another source (outside the Poshmark portal), you need to secure one.{' '}
        </p>

        <h3>5 Tips in Buying Wholesale on Poshmark </h3>
        <h4>1. Always Check the MOQ </h4>
        <p>
          Buying wholesale means buying items in bulk, resulting in an affordable price compared to buying at a retail
          price. However, you must always look for the MOQ or Minimum Order Quantities of an item you want to purchase.
          In most cases, MOQ is 10+ per item to avail the wholesale price. Most often than not. you can also get a
          better deal by negotiating the price by availing items higher than MOQ, and paying in cash.{' '}
        </p>

        <h4>2. Product Research </h4>
        <p>
          If you are trying on new products or categories, you may want to research the brands or items first. Look for
          similar items listed on the Poshmark or other platforms and check whether they are selling well or not.
          Remember, you are buying in bulk, so it is better to be familiarized with the product or brand first.{' '}
        </p>

        <h4>3. Pricing </h4>
        <p>
          Pricing your items right plays a vital role in selling items in your closet. If you are unsure how much to
          price your new inventory, check the MSRP or Manufacturer’s Suggested Retail Price. Most brands on the
          Wholesale portal provide MSRP to help you calculate and get the most value.{' '}
        </p>
        <p>
          You may also check similar items listed on Poshmark, Depop, Etsy, etc., and try to price your items close or a
          little lower than your competitors. In this way, more potential buyers will purchase from your shop.{' '}
        </p>

        <h4>4. Make Sure You Have Enough Funds</h4>
        <p>
          When buying in bulk, make sure you have enough funds to stock up your inventory. Check out the least expensive
          items you can find on the Posh market first before buying expensive items or brands unless you know how to
          sell them fast.{' '}
        </p>
        <p>
          Most of the new Poshmark sellers started with a few hundred bucks that grew into a full-time business earning
          six figures or more in their annual sales. Building your shop takes patience, time, and excellent management
          skills. If you want to venture out and source outside the Poshmark, you can try sourcing at thrift stores such
          as Goodwill or buying items at low costs sites like eBay and Tradesy.
        </p>

        <h4>5. Right Marketing Tool </h4>
        <p>
          Most of the new sellers are unaware of how marketing plays a vital role in the success of their business.
          Remember that to be able to sell an item; it needs to be seen by more potential buyers. Most new sellers are
          uninformed that even a misspelled brand name or items on their title and listing descriptions can affect their
          reach.{' '}
        </p>
        <p>
          Sharing your closet is the key to keeping your closet fresh and up to date. It is also a proven way to stay on
          top of search results pages and top of your follower’s feed. Unfortunately for sellers with big closets, this
          is a very laborious and time-consuming task.{' '}
        </p>
        <p>
          Fortunately, automation software tools such as OneShop help sellers optimize their listings and do most of the
          manual work that comes with it. OneShop acts as your marketing expert 24/7 that lets you save time from doing
          tedious tasks of manually sharing and uploading each of your listings on multiple marketplaces. It has an
          easy-to-use interface, innovative system, and tools custom-fit to sellers like you.{' '}
        </p>
        <p>
          With OneShop, you can save a day of work every week and focus on more important tasks. Never worry about
          keeping your closet on top by our automated shares, which gives you more visibility to more potential buyers.{' '}
        </p>
        <p>
          Try it today and kickstart your online shop! Sign-up and register for free to enjoy a 7-day free trial with no
          credit card information required!{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
